export const jaLanguage = {
    "Pensil Keyword": "Japanese",
    "Home": "家",
    "Explore Groups": "グループを探索する",
    "Events": "イベント",
    "Groups": "グループ",
    "Links": "リンク",
    "Direct Message": "ダイレクトメッセージ",
    "Powered by": "搭載",
    "No groups here, please use + to create a new one, or join one see them here.": "ここにはグループがありません。+ を使用して新しいグループを作成するか、ここでグループに参加してください。",
    "Please join a group to see them here": "ここで見るにはグループに参加してください",
    "Section can only be reordered within the group!": "セクションはグループ内でのみ並べ替えることができます。",
    "Group Page": "グループページ",
    "Invite Members": "メンバーを招待する",
    "Join": "参加する",
    "Joined": "参加しました",
    "Create new section": "新しいセクションを作成する",
    "Group Setting drop down": "グループ設定ドロップダウン",
    "Share": "共有",
    "Edit group": "グループの編集",
    "Delete group": "グループの削除",
    "Leave": "離れる",
    "Are you sure you want to delete the group?": "グループを削除してもよろしいですか?",
    "Cancel": "キャンセル",
    "Yes, Go Ahead": "はい、どうぞ",
    "Share via link": "リンク経由で共有",
    "Copy": "コピー",
    "Copied": "コピーされました",
    "Share on social media": "ソーシャルメディアで共有する",
    "Add Section": "セクションの追加",
    "Section Header": "セクションヘッダー",
    "Live": "ライブ",
    "Create Post": "投稿の作成",
    "Notificaiton Bell": "通知ベル",
    "All posts": "すべての投稿",
    "Admin posts only": "管理者の投稿のみ",
    "None": "なし",
    "Section Setting drop down": "セクション設定ドロップダウン",
    "Edit Section": "セクションの編集",
    "Embed Section": "セクションを埋め込む",
    "Delete Section": "セクションの削除",
    "Are you sure you want to delete the section?": "セクションを削除してもよろしいですか?",
    "Section deleted!": "セクションが削除されました!",
    "Create Group Pop up / Update": "グループ作成ポップアップ/更新",
    "Create group": "グループの作成",
    "Basic Detail": "基本的な詳細",
    "Settings": "設定",
    "Size 16:9 or 1600 by 900": "サイズ 16:9 または 1600 x 900",
    "Group name": "グループ名",
    "Enter group name": "グループ名を入力してください",
    "Suggestions: Spaces, Channels, Groups, Blog, Knowledgebase, etc": "提案: スペース、チャネル、グループ、ブログ、ナレッジベースなど",
    "Group Description": "グループの説明",
    "Enter description here": "ここに説明を入力してください",
    "Group Type": "グループタイプ",
    "Open": "開ける",
    "Visible to all & anyone can join": "全員が閲覧可能で誰でも参加可能",
    "Closed": "閉店",
    "User will have to request to join the group": "ユーザーはグループへの参加をリクエストする必要があります",
    "Paid": "有料",
    "Group Price": "団体料金",
    "Currency (Default: INR)": "通貨 (デフォルト: INR)",
    "User will have to pay to join the group": "ユーザーはグループに参加するには料金を支払う必要があります",
    "Make this a private group": "これをプライベートグループにします",
    "Private group will only be visible to members who are part of it. Admin can add members manually from member list": "プライベート グループは、そのメンバーであるメンバーのみに表示されます。管理者はメンバーリストから手動でメンバーを追加できます",
    "Upload from device": "デバイスからアップロードする",
    "Search image": "画像検索",
    "Valid group name required!": "有効なグループ名が必要です!",
    "Update Group": "アップデートグループ",
    "SEO Settings": "SEO設定",
    "Custom URL": "カスタムURL",
    "Meta Title": "メタタイトル",
    "Maximum length of 255 characters allowed": "最大長は 255 文字です",
    "Meta Description": "メタディスクリプション",
    "Open Graph Detail": "グラフの詳細を開く",
    "Open Graph Title": "グラフのタイトルを開く",
    "Open Graph Description": "グラフの説明を開く",
    "Open Graph Image": "グラフ画像を開く",
    "Recommended dimensions: 1200px by 630px with a 1.91:1 aspect ratio.": "推奨サイズ: 1200 ピクセル x 630 ピクセル、アスペクト比 1.91:1。",
    "If no URL is used, it will automatically picked your group thumbnail.": "URL が使用されない場合は、グループのサムネイルが自動的に選択されます。",
    "Create Section Pop up / Update": "セクション作成ポップアップ/更新",
    "Create Section": "セクションの作成",
    "Section Name": "セクション名",
    "Suggestions: General, Introductions, Community Guidelines": "提案: 一般、紹介、コミュニティ ガイドライン",
    "Section Type": "セクションタイプ",
    "Post Type": "投稿タイプ",
    "Group Chat": "グループチャット",
    "Who can post in this section?": "このセクションには誰が投稿できますか?",
    "Only Admin": "管理者のみ",
    "Any user": "任意のユーザー",
    "Sorting order for section": "セクションの並べ替え順序",
    "Latest first": "最新順",
    "Oldest post first": "最も古い投稿が最初に表示されます",
    "Section Appearance": "セクションの外観",
    "List View": "リストビュー",
    "Grid View": "グリッドビュー",
    "Make this closed section": "このクローズドセクションを作成します",
    "Members will have to request access to see section content": "メンバーはセクションのコンテンツを表示するにはアクセスをリクエストする必要があります",
    "Make this a private section": "ここを非公開セクションにします",
    "Disables requests (Make sure closed section is selected as well).": "リクエストを無効にします (閉じたセクションも選択されていることを確認してください)。",
    "Post Editor": "投稿編集者",
    "Create new post in": "に新しい投稿を作成します",
    "Add Cover Picture": "カバー写真を追加する",
    "Heading (Optional)": "見出し (オプション)",
    "Write here..": "ここに書いてください。",
    "Picture": "写真",
    "Video": "ビデオ",
    "Attachment": "アタッチメント",
    "Poll": "投票",
    "Embed Code": "コードを埋め込む",
    "Tags": "タグ",
    "Toggle to question": "質問に切り替えます",
    "Poll expire time": "投票期限切れ時間",
    "Poll question": "アンケートの質問",
    "Enter Question": "質問を入力してください",
    "Question": "質問",
    "Option": "オプション",
    "Options": "オプション",
    "Add Option": "オプションの追加",
    "Poll Expiry time": "ポーリング有効期限",
    "12 Hours": "12時間",
    "1 Day": "1日",
    "2 Days": "2日間",
    "1 Week": "1週間",
    "2 Weeks": "2週間",
    "Always Open": "常時オープン",
    "Write embeddable code": "埋め込み可能なコードを書く",
    "Click here to add embed code.": "ここをクリックして埋め込みコードを追加します。",
    "Paste your embed code here!": "ここに埋め込みコードを貼り付けてください。",
    "Post Settings": "投稿設定",
    "Update Post": "投稿を更新する",
    "Update": "アップデート",
    "Start meeting / Video call / Live": "ミーティング/ビデオ通話/ライブを開始",
    "Meeting Name": "会議名",
    "Suggestion: Group discussion etc": "提案：グループディスカッションなど",
    "Description": "説明",
    "Enter description here (optional)": "ここに説明を入力してください (オプション)",
    "When do you want to start the session": "セッションをいつ開始したいですか",
    "Right now": "今すぐ",
    "Schedule for later": "後の予定を立てる",
    "Group video call": "グループビデオ通話",
    "Webinar": "ウェビナー",
    "Go Live": "ライブに移行",
    "Info on the Post": "投稿に関する情報",
    "Post comment": "コメントを投稿する",
    "Comment": "コメント",
    "Comments": "コメント",
    "Reply": "返事",
    "Replies": "返信",
    "Share via URL": "URL経由で共有",
    "Reshare in other sections": "他のセクションで再共有する",
    "Post Card Drop Down": "ポストカードドロップダウン",
    "Bookmark": "ブックマーク",
    "Pin post": "ピンポスト",
    "Edit": "編集",
    "Embed Post": "投稿を埋め込む",
    "Delete": "消去",
    "Remove Pin": "ピンを外す",
    "Remove Bookmark": "ブックマークを削除",
    "Just copy paste this code wherever you want it to be embedded": "このコードをコピーして埋め込みたい場所に貼り付けるだけです",
    "Height": "身長",
    "Preview": "プレビュー",
    "Copied to clipboard": "クリップボードにコピーされました",
    "Select Widgets": "ウィジェットの選択",
    "Add widgets to": "ウィジェットを追加する",
    "You can change their order by dragging & dropping the widgets over each other": "ウィジェットを相互にドラッグ＆ドロップすることで順序を変更できます",
    "Please note: Widget wont be displayed if there is no data available,": "注意: 利用可能なデータがない場合、ウィジェットは表示されません。",
    "Group Members": "グループメンバー",
    "Group Leaderboard": "グループリーダーボード",
    "Community Leaderboard": "コミュニティリーダーボード",
    "Trending Posts": "注目の投稿",
    "Group Events": "グループイベント",
    "Add Custom": "カスタムの追加",
    "Save Widgets": "ウィジェットの保存",
    "Visible to user": "ユーザーに表示される",
    "Visible to admin": "管理者に表示されます",
    "Add widget to": "ウィジェットを追加する",
    "Upload cover picture": "カバー写真をアップロードする",
    "1:1 aspect ration (recommended)": "アスペクト比 1:1 (推奨)",
    "Card Title": "カードタイトル",
    "Enter widget name": "ウィジェット名を入力してください",
    "Small Description (try to keep it under 50 words)": "簡単な説明 (50 単語以内に収めるようにしてください)",
    "Enter description": "説明を入力してください",
    "Button Title": "ボタンのタイトル",
    "Enter button name": "ボタン名を入力してください",
    "Siggestion: Know more, Join, Apply, etc": "サイン: 詳細を知る、参加する、申し込むなど",
    "URL link": "URLリンク",
    "Create custom widget": "カスタムウィジェットを作成する",
    "Custom widget created successfully": "カスタム ウィジェットが正常に作成されました",
    "Widgets": "ウィジェット",
    "Members": "メンバー",
    "See All": "すべて見る",
    "Communtiy Top Contributors": "コミュニティのトップレベルの貢献者",
    "Community Members": "コミュニティメンバー",
    "Group Top Contributors": "グループのトップレベルの貢献者",
    "Upcoming Events": "今後のイベント",
    "Home Page Banner": "ホームページのバナー",
    "Edit Banner": "バナーの編集",
    "Home page Edit Banner Pop up": "ホームページ編集バナーポップアップ",
    "Update Banner": "バナーを更新",
    "Search": "検索",
    "Upload Image": "画像をアップロードする",
    "Remove": "取り除く",
    "Banner image (please use 16:6 ratio or 1600px by 600px image for the best view)": "バナー画像 (最適な表示を得るには、16:6 比率または 1600 ピクセル x 600 ピクセルの画像を使用してください)",
    "Banner Title": "バナータイトル",
    "Enter here": "ここに入力してください",
    "Suggestion: Welcome to my community etc": "提案: 私のコミュニティへようこそなど",
    "Banner Description": "バナーの説明",
    "Enter banner description": "バナーの説明を入力してください",
    "Save Banner Info": "バナー情報の保存",
    "Home Page Feed": "ホームページフィード",
    "Recent": "最近の",
    "Top Posts": "人気の投稿",
    "Trending": "トレンド",
    "Home Feed Groups": "ホームフィードグループ",
    "": "#VALUE!",
    "My Profile": "私のプロフィール",
    "Logout": "ログアウト",
    "Notification": "通知",
    "Notifications": "通知",
    "Mark all viewed": "すべて閲覧済みとしてマークする",
    "has created a post": "投稿を作成しました",
    "wants to join": "参加したいです",
    "has commented on your post": "あなたの投稿にコメントしました",
    "has replied to your comment": "あなたのコメントに返信しました",
    "Search for tags": "タグを検索する",
    "All groups": "すべてのグループ",
    "Search result": "検索結果",
    "No post found for selected hashtag": "選択したハッシュタグの投稿が見つかりませんでした",
    "Start a conversation": "会話を始める",
    "Search by name": "名前で検索",
    "Upcoming": "今後の予定",
    "UPCOMING": "今後の予定",
    "Past": "過去",
    "PAST": "過去",
    "No upcoming events": "今後のイベントはありません",
    "Create event popup": "イベントポップアップを作成する",
    "Event details": "イベント詳細",
    "16:9 aspect ratio": "16:9 アスペクト比",
    "Event name": "イベント名",
    "Enter event name": "イベント名を入力してください",
    "Host Name": "ホスト名",
    "You will be made host if none selected": "何も選択されていない場合は、あなたがホストになります",
    "Write here...": "ここに書いてください...",
    "No. of registration for the event": "イベント登録数",
    "Unlimited": "無制限",
    "When & where": "いつ、どこで",
    "From": "から",
    "Start date": "開始日",
    "time": "時間",
    "To": "に",
    "End date": "終了日",
    "Current time zone:": "現在のタイムゾーン:",
    "Can be updated from the communtiy setting": "コミュニティ設定から更新可能",
    "Online event": "オンラインイベント",
    "Add meeting link": "会議リンクを追加",
    "Meeting link will be generated once event is created": "イベントが作成されると会議リンクが生成されます",
    "Venue": "会場",
    "Enter address": "住所を入力してください",
    "Create": "作成する",
    "Invite": "招待する",
    "Share event via link": "リンク経由でイベントを共有する",
    "Copy__1": "コピー",
    "Select section to post this event": "このイベントを投稿するセクションを選択してください",
    "Once posted, members of that group or section will recieve an notification": "投稿されると、そのグループまたはセクションのメンバーは通知を受け取ります",
    "Post": "役職",
    "RSVP": "お返事お願いします",
    "Book Event": "書籍イベント",
    "Yes, I'll attend": "はい、参加します",
    "May be": "多分",
    "No, I won't attend": "いいえ、参加しません",
    "Date & Time": "日付と時刻",
    "Host": "ホスト",
    "Online meeting": "オンライン会議",
    "Meeting link will be visible once registered for the event": "イベントに登録すると、ミーティングのリンクが表示されます",
    "User Management": "ユーザー管理",
    "Go bac to community": "コミュニティに戻る",
    "Manage Members": "メンバーの管理",
    "Member": "メンバー",
    "Invited": "招待されました",
    "Search for member": "メンバーを探す",
    "Add to group": "グループに追加",
    "Send Direct Message": "ダイレクトメッセージを送信する",
    "Change role": "役割を変更する",
    "Kick from community": "コミュニティからキックする",
    "Super Admin": "スーパー管理者",
    "Super admin will have full access to the communtiy settings": "スーパー管理者はコミュニティ設定に完全にアクセスできます",
    "Group Admin": "グループ管理者",
    "Admin of the selected group can edit the group information and create, edt or delete section under selected group": "選択したグループの管理者は、グループ情報を編集し、選択したグループの下にセクションを作成、編集、または削除できます。",
    "Group Moderator": "グループモデレーター",
    "Group moderator can create or delete post, comment, reply & messages in the selected group.": "グループモデレーターは、選択したグループ内の投稿、コメント、返信、メッセージを作成または削除できます。",
    "User": "ユーザー",
    "Save": "保存",
    "User role updated successfully": "ユーザー役割が正常に更新されました",
    "Leaderboard": "リーダーボード",
    "Click on the column header for sorting": "並べ替えるには列ヘッダーをクリックします",
    "Rank": "ランク",
    "Karma Points": "カルマポイント",
    "Custom Points": "カスタムポイント",
    "Follow": "フォローする",
    "Upvotes": "賛成票",
    "Posts": "投稿",
    "Add custom points": "カスタムポイントを追加する",
    "Subtract custom points": "カスタムポイントを減算する",
    "Enter no. of points": "いいえを入力してください。ポイントの",
    "Add points": "ポイントを追加する",
    "Invite members to": "メンバーを招待する",
    "Invite via link": "リンク経由で招待する",
    "Invite via email": "メールで招待する",
    "Add more": "さらに追加",
    "Upload a CSV": "CSVをアップロードする",
    "Please upload a comma-seprated CSV file, with header as name, email.": "ヘッダーを名前、電子メールとして、カンマ区切りの CSV ファイルをアップロードしてください。",
    "Here is a template CSV file": "テンプレートCSVファイルはこちら",
    "Upload File": "ファイルをアップロードする",
    "Send Invite": "招待を送信する",
    "Mail Template": "メールテンプレート",
    "Send Test Mail": "テストメールを送信する",
    "Hey": "おい",
    "A has invite you to join the B": "A があなたを B に招待しました",
    "Switch to rich text editor": "リッチテキストエディタに切り替える",
    "Add Custom Message": "カスタムメッセージの追加",
    "Enter message here": "ここにメッセージを入力してください",
    "Send Bulk Mail": "一括メールを送信する",
    "Send Mail": "メールを送信する",
    "Send bulk mail to all community members or select group members": "すべてのコミュニティ メンバーまたは選択したグループ メンバーに一括メールを送信する",
    "Date": "日付",
    "Subject": "主題",
    "Recipients": "受信者",
    "1000 bulk emails remaining for this month. Resets on <date>": "今月の一括メールは残り 1000 件です。 <日付> にリセットします",
    "Everyone": "みんな",
    "Enter mail subject": "メールの件名を入力してください",
    "Write message": "メッセージを書く",
    "Cancel__1": "キャンセル",
    "Send": "送信",
    "__1": "#VALUE!",
    "Activity": "活動",
    "Bookmarks": "ブックマーク",
    "Edit Profile": "プロフィールの編集",
    "Unsubscribe": "購読を解除する",
    "Settings (Account)": "設定（アカウント）",
    "Profile": "プロフィール",
    "Set Profile Picture": "プロフィール写真を設定する",
    "Your name": "あなたの名前",
    "User ID": "ユーザーID",
    "Short bio": "短い略歴",
    "Link your social account": "ソーシャルアカウントをリンクする",
    "This will be displayed on your profile": "これはプロフィールに表示されます",
    "Add social handle": "ソーシャルハンドルを追加",
    "Verification": "検証",
    "Account Verification": "アカウントの認証",
    "Email": "電子メール",
    "Enter email": "メールアドレスを入力してください",
    "Verified": "確認済み",
    "Unverified": "未検証",
    "Change": "変化",
    "Unlink": "リンクを解除する",
    "Mobile": "携帯",
    "enter mobile no.": "携帯電話番号を入力してください",
    "Request OTP": "OTP をリクエストする",
    "Manage your personal account notification preferences": "個人アカウントの通知設定を管理する",
    "Prefrences": "好み",
    "Email notification": "電子メール通知",
    "Notify me about comments on my posts": "自分の投稿へのコメントについて通知する",
    "Notify me about replies on my comments": "コメントへの返信について通知する",
    "Notify me about upvotes on my posts": "自分の投稿に対する賛成票について通知する",
    "Notify me about reaction on my comments": "私のコメントに対する反応について通知する",
    "Notify me about reaction on my reply": "私の返信に対する反応について通知する",
    "Notify me about direct message": "ダイレクトメッセージについて通知する",
    "Notify me about my mentions": "私のメンションについて通知する",
    "Notification for new posts": "新しい投稿の通知",
    "Only group & section available which you are part of": "あなたが所属しているグループとセクションのみが利用可能です",
    "Group & Section": "グループとセクション",
    "All activity": "すべてのアクティビティ",
    "Post by admin": "管理者による投稿",
    "No Notification": "通知なし",
    "Setting (Community)": "設定（コミュニティ）",
    "General Settings": "一般設定",
    "Upload community logo": "コミュニティロゴをアップロードする",
    "Community name": "コミュニティ名",
    "Invalid field": "無効なフィールド",
    "Your community address": "コミュニティのアドレス",
    "Fav icon": "お気に入りアイコン",
    "This will be visible on the browser tab (32px by 32px)": "これはブラウザのタブに表示されます (32 ピクセル x 32 ピクセル)。",
    "TimeZone": "タイムゾーン",
    "Privacy Policy on login page": "ログインページのプライバシーポリシー",
    "Terms & Condition on login page": "ログインページの利用規約",
    "Enter link here": "ここにリンクを入力してください",
    "Open Group Image": "グループ画像を開く",
    "By default ir takes up the community banner uploaded with the communtiy": "デフォルトでは、IR はコミュニティとともにアップロードされたコミュニティ バナーを取り上げます。",
    "Community Experience": "コミュニティ体験",
    "Onboarding": "オンボーディング",
    "Make your community private": "コミュニティを非公開にする",
    "Users will have to login or sign up to access the community": "ユーザーがコミュニティにアクセスするにはログインまたはサインアップする必要があります",
    "Make account verification mandatory for both email & mobile": "電子メールとモバイルの両方でアカウント認証を必須にする",
    "New user will have to verify both email & mobile no. to access the community": "新規ユーザーは電子メールと携帯電話番号の両方を確認する必要があります。コミュニティにアクセスするには",
    "Admin will also have to verify their mobile no. & email or else they won't be able to access the community": "管理者は携帯電話番号も確認する必要があります。メールを送信しないとコミュニティにアクセスできなくなります",
    "Gated community access": "ゲート付きコミュニティへのアクセス",
    "Admin will have to approve or reject user's requests to join the community": "管理者はユーザーのコミュニティへの参加リクエストを承認または拒否する必要があります",
    "Disable mobile login/register": "モバイルログイン/登録を無効にする",
    "Disable email login/register": "電子メールのログイン/登録を無効にする",
    "Disable google login/register": "Googleログイン/登録を無効にする",
    "Disable facebook login/register": "Facebookのログイン/登録を無効にする",
    "Show & Hide features": "表示と非表示の機能",
    "Hide direct chat": "ダイレクトチャットを非表示にする",
    "User will not be able to send direct messages to each other": "ユーザーは相互にダイレクトメッセージを送信できなくなります",
    "Hide profile picture from top right corner for mobile responsive view": "モバイル対応ビューでは右上隅のプロフィール写真を非表示にします",
    "Useful when using community in an in app browser": "アプリ内ブラウザでコミュニティを使用する場合に便利です",
    "Hide profile picture from top right corner in every view": "すべてのビューで右上隅のプロフィール写真を非表示にします",
    "Disable header dropdown on profile picture": "プロフィール写真のヘッダー ドロップダウンを無効にする",
    "Useful for integrated community, especially using SSO": "統合コミュニティ、特に SSO を使用する場合に役立ちます",
    "Hide the communtiy logo from the header": "ヘッダーからコミュニティのロゴを非表示にする",
    "Hide the communtiy title from the header": "ヘッダーからコミュニティのタイトルを非表示にする",
    "Show collpased group in the side nav bar": "折りたたまれたグループをサイド ナビゲーション バーに表示する",
    "Show full expanded post in the home feed": "ホームフィードに展開された投稿全体を表示する",
    "Hide the leaderboard score from the header": "ヘッダーからリーダーボードのスコアを非表示にする",
    "Show powered by Pensil": "Pensil によるショー",
    "Hide closed groups if not joined": "参加していない場合は非公開グループを非表示にする",
    "Closed groups would not be shown to the user if they are not a member of the group": "閉じられたグループは、グループのメンバーではない場合、ユーザーには表示されません。",
    "Hide Community subscriber count from the users": "コミュニティの登録者数をユーザーから非表示にする",
    "This will hide the community subscriber list in the community header": "これにより、コミュニティ ヘッダーのコミュニティ購読者リストが非表示になります。",
    "Disable Communtiy Switcher": "コミュニティスイッチャーを無効にする",
    "Use MD editor for create post description": "投稿の説明を作成するには MD エディタを使用します",
    "Non logged in user will land on explore group page instead of post directory": "ログインしていないユーザーは、投稿ディレクトリではなくエクスプローラー グループ ページにアクセスします。",
    "Advanced configurable": "高度な構成可能",
    "Communtiy default country code": "コミュニティのデフォルトの国コード",
    "This will show up by default on login/signup": "これはログイン/サインアップ時にデフォルトで表示されます",
    "Onboarding/Welcome Message": "オンボーディング/ウェルカムメッセージ",
    "Welcome Message": "ウェルカムメッセージ",
    "Greet your members with personalized message": "パーソナライズされたメッセージでメンバーに挨拶します",
    "Welcome to": "へようこそ",
    "Message": "メッセージ",
    "Add message": "メッセージを追加",
    "Custom domain": "カスタムドメイン",
    "Add custom domain": "カスタムドメインの追加",
    "Create new request": "新しいリクエストを作成する",
    "Enter your custom domain": "カスタム ドメインを入力してください",
    "Setup details": "セットアップの詳細",
    "Add a CNAME record in your domain pointing to this community's address": "このコミュニティのアドレスを指す CNAME レコードをドメインに追加します",
    "To configure your domain, you'll need to add a CNAME record pointing your domain to your pensil community URL": "ドメインを設定するには、ドメインを Pensil コミュニティ URL に指す CNAME レコードを追加する必要があります。",
    "Step by Step help apge": "ステップバイステップヘルプ apge",
    "All request list": "全リクエストリスト",
    "Allow admin to assign/un-assign custom points to users": "管理者がユーザーにカスタム ポイントを割り当て/割り当て解除できるようにする",
    "Base points for user to begin with": "ユーザーが最初に使用するベースポイント",
    "Base points will be updated for all the users, any changes will reflect for all the users.": "ベースポイントはすべてのユーザーに対して更新され、変更はすべてのユーザーに反映されます。",
    "Allocate points for interaction": "インタラクションにポイントを割り当てる",
    "Upvoting post": "賛成票を投じた投稿",
    "creating a comment": "コメントの作成",
    "creating a reply": "返信を作成する",
    "Getting upvote to their post": "自分の投稿に賛成票を集める",
    "Getting comment to their post": "投稿へのコメントの取得",
    "Getting reply to their comment": "コメントへの返信を取得する",
    "Creating a post": "投稿の作成",
    "Visiblity": "可視性",
    "Move Up": "上に移動",
    "Move Down": "下に移動",
    "Create embedded section": "埋め込みセクションの作成",
    "Preview area": "プレビューエリア",
    "Theme selector": "テーマセレクター",
    "Community Theme": "コミュニティのテーマ",
    "Select theme": "テーマの選択",
    "Select brand color": "ブランドカラーを選択してください",
    "Customize your button color to match your brand": "ブランドに合わせてボタンの色をカスタマイズします",
    "Select on button text color": "ボタンの文字色を選択してください",
    "Suggestion: Keep inverted contrast against brand color": "提案: ブランドカラーに対してコントラストを反転させてください",
    "Billing": "請求する",
    "Current plan": "現在の計画",
    "You are current on Free PLan": "現在は無料プランをご利用中です",
    "Renew on: NA": "更新日: NA",
    "Select": "選択",
    "Email us at": "メールでご連絡ください",
    "Compare plan": "プランを比較する",
    "API Keys": "APIキー",
    "Create new key": "新しいキーを作成する",
    "Total keys": "キーの合計",
    "Keep your API keys safe! You can use them to access specific feature & let cetain apps perfrom certain actions on your behalf on the platform.": "API キーを安全に保管してください。これらを使用すると、特定の機能にアクセスしたり、プラットフォーム上で特定のアプリに特定のアクションを実行させたりすることができます。",
    "Key name": "キー名",
    "Key value": "キーの値",
    "Action": "アクション",
    "Group updated!": "グループ更新しました！",
    "Are you sure you want to": "本当によろしいですか",
    "Make Moderator": "モデレーターにする",
    "Remove from group": "グループから削除",
    "Show All": "すべて表示",
    "Change Role": "役割の変更",
    "Close": "近い",
    "copy": "コピー",
    "LINKS": "リンク",
    "Email Id": "メールID",
    "Name": "名前",
    "Search for an image": "画像を検索する",
    "Crop Image": "画像のトリミング",
    "No photos found": "写真が見つかりませんでした",
    "Community": "コミュニティ",
    "Banner ratio - 16:9": "バナー比率 - 16:9",
    "Banner Ratio - 16:6": "バナー比率 - 16:6",
    "Share on mail": "メールで共有する",
    "Share on Telegram": "テレグラムでシェアする",
    "Share on Whatsapp": "Whatsappで共有する",
    "Share on Linkedin": "Linkedin で共有する",
    "Share on Facebook": "Facebook でシェアする",
    "Share on Twitter": "Twitterでシェアする",
    "Pin Post": "ピンポスト",
    "Heading (optional)": "見出し (オプション)",
    "Select section": "セクションを選択",
    "Gif": "GIF",
    "Create Custom Widget": "カスタムウィジェットの作成",
    "Are you sure you want to delete this widget?": "このウィジェットを削除してもよろしいですか?",
    "Go to event": "イベントに行く",
    "Add Tags": "タグを追加する",
    "Create Tag": "タグの作成",
    "Title (Optional)": "タイトル (オプション)",
    "Search Gif": "GIFを検索",
    "What's on your mind": "何を考えているの",
    "Looks like nothing available here right now.": "現在ここでは何も入手できないようです。",
    "Try exploring other tabs": "他のタブを調べてみる",
    "Delete Widget": "ウィジェットの削除",
    "Please select a section to post": "投稿するセクションを選択してください",
    "Post added successfully!": "投稿が正常に追加されました。",
    "Failed to create post. Please check post content and retry again.": "投稿の作成に失敗しました。投稿内容を確認して、もう一度やり直してください。",
    "Are you sure you want to discard current post?": "現在の投稿を破棄してもよろしいですか?",
    "By default it will take up the image uploaded with the post": "デフォルトでは、投稿と一緒にアップロードされた画像が使用されます",
    "Quiz can be only viewed and attempted from mobile device right now!": "現在、クイズはモバイル デバイスからのみ表示および挑戦できます。",
    "Community Banner": "コミュニティバナー",
    "Change Cover": "カバーを変更する",
    "Suggestions: Welcome to my community etc": "関連用語: 私のコミュニティへようこそ など",
    "(edited)": "(編集済み)",
    "Aspect ratio (recommended)": "アスペクト比 (推奨)",
    "Banner details updated!": "バナー詳細を更新しました！",
    "Refresh if changes are not visible!": "変更が表示されない場合は更新してください。",
    "Banner details could not be updated!": "バナーの詳細を更新できませんでした。",
    "Post deleted": "投稿が削除されました",
    "Post not available. It may have been deleted.": "ポストは利用できません。削除された可能性があります。",
    "Admin": "管理者",
    "Moderator": "モデレータ",
    "Bookmark added!": "ブックマークが追加されました！",
    "Bookmark removed": "ブックマークが削除されました",
    "Failed performing action!": "アクションの実行に失敗しました!",
    "Copy this link to share on other platforms": "他のプラットフォームで共有するには、このリンクをコピーしてください",
    "View this event": "このイベントを見る",
    "Event": "イベント",
    "Join Meeting": "ミーティングに参加する",
    "The live meeting has ended": "ライブミーティングは終了しました",
    "read more...": "続きを読む...",
    "Load more comments": "さらにコメントを読み込む",
    "Post Reply": "返信を投稿する",
    "Post Comment": "コメントを投稿する",
    "more": "もっと",
    "upvoted": "賛成票を投じた",
    "1 Upvote": "1 賛成票",
    "1 Comment": "1 コメント",
    "Please enter a title": "タイトルを入力してください",
    "Please enter a url link": "URLリンクを入力してください",
    "Please enter button title": "ボタンのタイトルを入力してください",
    "Button label must be at least 20 characters": "ボタンのラベルは 20 文字以上である必要があります",
    "Please enter valid url": "有効なURLを入力してください",
    "Suggestions: Know more, Join, Apply...": "提案: もっと詳しく知る、参加する、申し込む...",
    "URL": "URL",
    "Community Events": "コミュニティイベント",
    "Widget deleted successfully": "ウィジェットが正常に削除されました",
    "Community Top Contributors": "コミュニティのトップレベルの貢献者",
    "points": "ポイント",
    "Points cannot be greater than current points": "現在のポイントを超えるポイントは設定できません",
    "Point cannot be a negative value": "ポイントを負の値にすることはできません",
    "Point cannot be a decimal point": "ポイントに小数点は使用できません",
    "Please enter a valid number": "有効な番号を入力してください",
    "Karma points updated successfully": "カルマポイントが正常に更新されました",
    "Error in updating karma points": "カルマポイントの更新エラー",
    "Add karma points": "カルマポイントを追加する",
    "Minus karma points": "マイナスカルマポイント",
    "Total Karma points:": "合計カルマポイント:",
    "Enter no. of karma points": "いいえを入力してください。カルマポイントの",
    "Minus Points": "マイナスポイント",
    "Trending Post": "トレンドの投稿",
    "No visible description": "目に見える説明はありません",
    "Picture ratio: 1:1": "画像比率: 1:1",
    "home feed": "ホームフィード",
    "Event name is invalid!": "イベント名が無効です!",
    "custom": "カスタム",
    "Custom widget updated successfully": "カスタム ウィジェットが正常に更新されました",
    "Name invalid!": "名前が無効です!",
    "Current timezone:": "現在のタイムゾーン:",
    "can be updated from community settings": "コミュニティ設定から更新できます",
    "Event created successfully": "イベントが正常に作成されました",
    "Error in creating event": "イベント作成時のエラー",
    "Attendees": "出席者",
    "Do you wish to notify these changes to attendees?": "これらの変更を出席者に通知しますか?",
    "users wants to attend this event": "ユーザーはこのイベントに参加したいと考えています",
    "Yes, Notify them": "はい、通知します",
    "No, its okay": "いいえ、大丈夫です",
    "Do you wish to notify that event is cancelled?": "イベントが中止になったことを通知しますか?",
    "Are you sure you want to delete the event?": "イベントを削除してもよろしいですか?",
    "Delete Event": "イベントの削除",
    "New Event": "新しいイベント",
    "Accept Invitation": "招待を承諾する",
    "Requested": "リクエスト済み",
    "Declined": "拒否されました",
    "Request Access": "アクセスのリクエスト",
    "Enroll for": "登録する",
    "Housefull": "ハウスフル",
    "Just copy paste this code wherever you want it to be embedded:": "このコードをコピーして、埋め込みたい場所に貼り付けるだけです。",
    "Ended": "終了しました",
    "Error getting events": "イベント取得エラー",
    "Events could not be fetched!": "イベントを取得できませんでした。",
    "Show Attendees": "出席者を表示する",
    "Subscribers": "購読者",
    "Make this a closed section": "ここをクローズドセクションにします",
    "Update Section": "更新セクション",
    "Valid section name required!": "有効なセクション名が必要です!",
    "Enter section name": "セクション名を入力してください",
    "Community Admin": "コミュニティ管理者",
    "Embed": "埋め込む",
    "Invite to": "に招待する",
    "Please enter a valid email address": "有効なメールアドレスを入力してください",
    "Invitation sent successfully": "招待状が正常に送信されました",
    "Error sending invitation": "招待状の送信エラー",
    "Email is not valid!": "電子メールが無効です!",
    "Data could not be loaded!": "データをロードできませんでした!",
    "Posted in": "で投稿される",
    "Invite Members Individually": "メンバーを個別に招待する",
    "Start a discussion": "ディスカッションを開始する",
    "Post something": "何かを投稿する",
    "Invite your audience": "視聴者を招待する",
    "Choose Plan": "プランを選択",
    "or": "または",
    "Create a link": "リンクを作成する",
    "Add link": "リンクを追加",
    "Update link": "リンクを更新する",
    "Add shortcut to your most used tools": "よく使うツールにショートカットを追加する",
    "Your website, Instagram Channel, Facebook profile etc": "ウェブサイト、Instagram チャンネル、Facebook プロフィールなど",
    "Valid link name required!": "有効なリンク名が必要です!",
    "Valid url required, and make sure you are not missing http:// or https://": "有効な URL が必要です。http:// または https:// を忘れていないことを確認してください。",
    "Invite to__1": "に招待する",
    "Link Name": "リンク名",
    "Link URL": "リンクURL",
    "Could not subscribe to": "購読できませんでした",
    "Subscribed to": "購読しました",
    "By default it will take up the community banner uploaded with the community": "デフォルトでは、コミュニティとともにアップロードされたコミュニティ バナーが表示されます。",
    "Created by": "作成者",
    "Online Event (Meeting link will be visible once registered for the event)": "オンライン イベント (イベントに登録すると、ミーティングのリンクが表示されます)",
    "Join Call": "通話に参加する",
    "Please login to book this event": "このイベントを予約するにはログインしてください",
    "Commented on": "コメントしました",
    "Replied to": "に返信しました",
    "Looks like it's lonely here.": "ここは寂しいようだ。",
    "Try exploring other sections and groups.": "他のセクションやグループを探索してみてください。",
    "Please proceed with the payment or contact admin to gain access to this group.": "支払いを続行するか、管理者に連絡してこのグループにアクセスしてください。",
    "This is a closed group You'll need access to this group.": "これは非公開のグループです。このグループにアクセスする必要があります。",
    "You have no bookmarks right now.": "現在ブックマークはありません。",
    "The user hasn't posted anything yet publicly.": "ユーザーはまだ何も公開していません。",
    "No activity to show.": "表示するアクティビティがありません。",
    "Are you sure you want to unsubscribe the community?": "コミュニティの購読を解除してもよろしいですか?",
    "deals left": "残りの取引",
    "Something went wrong while loading posts": "投稿の読み込み中に問題が発生しました",
    "Could not unsubscribe from": "購読を解除できませんでした",
    "Unsubscribed from": "からの購読を解除しました",
    "Login to view this page": "このページを表示するにはログインしてください",
    "Login": "ログイン",
    "There was some error while doing the action!": "アクションの実行中にエラーが発生しました。",
    "Unable to delete section!": "セクションを削除できません!",
    "__2": "",
    "__3": "",
    "__4": "",
    "Home page": "ホームページ",
    "Members Directory": "会員名簿",
    "Calendar": "カレンダー",
    "Create Group": "グループの作成",
    "Start Live Session": "ライブセッションを開始する",
    "Home__1": "家",
    "Following": "続く",
    "__5": "",
    "Post Card": "ポストカード",
    "Like": "のように",
    "Comment__1": "コメント",
    "Comment__2": "コメント",
    "Share__1": "共有",
    "Report": "報告",
    "Follow User": "ユーザーをフォローする",
    "Report User": "ユーザーを報告する",
    "Report Post": "レポート投稿",
    "__6": "",
    "LeaderBoard Floating pop up": "LeaderBoard フローティング ポップアップ",
    "Go to leaderboard": "リーダーボードに移動",
    "Total karma points": "合計カルマポイント",
    "Comments__1": "コメント",
    "Upvotes__1": "賛成票",
    "Replies__1": "返信",
    "Post__1": "役職",
    "Custom Points__1": "カスタムポイント",
    "Base Points": "ベースポイント",
    "__7": "",
    "Channel": "チャネル",
    "This is a private channel": "これはプライベートチャンネルです",
    "You'll need access to this channel": "このチャンネルにアクセスする必要があります",
    "__8": "",
    "Profile Page": "プロフィールページ",
    "Followers": "フォロワー",
    "Activities": "活動内容",
    "__9": "",
    "Settings Page": "設定ページ",
    "Go back to community": "コミュニティに戻る",
    "Account": "アカウント",
    "Notification Centre": "通知センター",
    "__10": "",
    "Edit Profile Page": "プロフィール編集ページ",
    "Set profile Picture": "プロフィール画像を設定する",
    "Your name__1": "あなたの名前",
    "Subtitle": "字幕",
    "(Max char 60)": "(最大文字数 60)",
    "User Id": "ユーザーID",
    "Short Bio": "略歴",
    "Link For Social Account": "ソーシャルアカウントのリンク",
    "This will be displayed on your profile__1": "これはプロフィールに表示されます",
    "Add Social handles": "ソーシャルハンドルを追加する",
    "__11": "",
    "Verification Page": "認証ページ",
    "Email__1": "電子メール",
    "Verified__1": "確認済み",
    "__12": "",
    "Manage your personal account notification preferences__1": "個人アカウントの通知設定を管理する",
    "Preferences": "設定",
    "Email Notification": "電子メール通知",
    "Notify me about comment on my posts": "私の投稿へのコメントについて通知する",
    "Notify me about replies on my comment": "私のコメントへの返信について通知する",
    "Notify me about upvote on my post": "自分の投稿に対する賛成票について通知する",
    "Notify me about reaction to my comment": "私のコメントに対する反応について通知する",
    "Notify me about reaction on my reply__1": "私の返信に対する反応について通知する",
    "Notify me about direct message__1": "ダイレクトメッセージについて通知する",
    "Notify me about mentions": "メンションについて通知する",
    "Notification for new posts__1": "新しい投稿の通知",
    "Only groups and channel available which you are part of. You can also control notification": "あなたが所属しているグループとチャンネルのみが利用可能です。通知を制御することもできます",
    "Group & Channels": "グループとチャンネル",
    "All Activity": "すべてのアクティビティ",
    "Post by admin__1": "管理者による投稿",
    "No Notification__1": "通知なし",
    "__13": "",
    "Direct Message__1": "ダイレクトメッセージ",
    "Inbox": "受信箱",
    "No chats found": "チャットが見つかりませんでした",
    "__14": "",
    "Create Post Popup": "投稿ポップアップの作成",
    "Create Post in": "投稿を作成する",
    "Select Channel": "チャンネルの選択",
    "__15": "",
    "Dark Mode": "ダークモード",
    "__16": "",
    "has created a post in": "に投稿を作成しました",
    "joined": "参加しました",
    "wants to join__1": "参加したいです",
    "liked your post!": "あなたの投稿にいいね！",
    "has commented on your post in": "のあなたの投稿にコメントしました",
    "has replied to your comment on a post in": "の投稿に対するあなたのコメントに返信しました",
    "has mentioned you in a post in": "の投稿であなたのことを言及しました",
    "has mentioned you in a comment": "コメントであなたについて言及しました",
    "has mentioned you in a reply": "返信であなたについて言及しました"
}